import {
  getRequest,
  putRequest,
  postRequest,
  handleRequest,
} from "../system/server-call";
// eslint-disable-next-line import/no-cycle
import responseHandler from "../system/server-response-handler";
import { API_URLS, hubConstants, loginConstants } from "../constants";
import {
  setItemToStorage,
  removeItemFromStorage,
  clearStorage,
  encryptObject,
  getItemFromStorage,
} from "../system";
import { ENV } from "../config/env";

/**
 * The Auth Service
 *
 * This is used for getting data from server and handling the business logic on that data
 */
// logging out the user from the app and removing its information from browser
const logout = () => {
  if (
    getItemFromStorage(hubConstants.FROM_HUB_KEY) ===
    hubConstants.FROM_SURVEY_VALUE
  ) {
    removeItemFromStorage(ENV.PAYLOAD);
    clearStorage();
    window.location.reload();
  }
  return Promise.resolve();
};

// handling the Login response, if user is authenticated then saving
// the jwt token in the local storage
const handleLoginResponse = (response) => {
  const { status } = response.data;
  if (status !== loginConstants.LOGIN_STATUS.SUCCESS) {
    logout();
    return responseHandler.handleServerResponse(response);
  }
  return response.data.payload;
};

// authenticating via token in param for admins coming from FR
const handleAdminToken = (response) => {
  if (!response) {
    logout();
    return responseHandler.handleServerResponse(response);
  }

  const ciphertext = encryptObject({
    response,
  });
  setItemToStorage(ENV.PAYLOAD, ciphertext);

  return response;
};

//Authenticating the user from server
const login = (userData) =>
  handleRequest(
    postRequest(API_URLS.AUTH.BASE, userData, false),
    handleLoginResponse
  );

// Send forgot-password email
const sendForgotPasswordEmail = (userData) =>
  handleRequest(
    postRequest(API_URLS.AUTH.FORGOT_PASSWORD, userData, false)
  );

//Reset password service
const resetPasswordByEncryptedParams = (encryptedParams) =>
  handleRequest(
    postRequest(API_URLS.AUTH.RESET_PASSWORD, encryptedParams, false)
  );

//Update user password service
const updateUserPassword = (body) =>
  handleRequest(putRequest(API_URLS.AUTH.BASE, body, false));

//Sending help message
const sendHelpMessage = (message) =>
  handleRequest(postRequest(API_URLS.REQUEST_HELP.BASE, message));

//Getting user by id
const getUserById = (userId) =>
  handleRequest(getRequest(`${API_URLS.PROFILE.GET_USER_BY_ID}/${userId}`));

const getAllBrandsWithFeatureFlags = () =>
  handleRequest(getRequest(API_URLS.FEATURE.BASE));

const updateClarityConsent = (data) =>
  handleRequest(putRequest(API_URLS.PROFILE.UPDATE_USER_CLARITY_CONSENT, data, false));

// Verifying user email from server
const verifyEmail = (body) =>
  handleRequest(postRequest(API_URLS.AUTH.VERIFY_EMAIL, body, false));

// Check email confirmation before continuing sign-in.
const confirmEmail = (body) =>
  handleRequest(postRequest(API_URLS.AUTH.CONSUMER_NAVIGATION, body, false));

// exporting functions for other files
export const authService = {
  login,
  logout,
  verifyEmail,
  getUserById,
  confirmEmail,
  sendHelpMessage,
  handleAdminToken,
  updateUserPassword,
  updateClarityConsent,
  sendForgotPasswordEmail,
  getAllBrandsWithFeatureFlags,
  resetPasswordByEncryptedParams,
};
